/**
 * @generated SignedSource<<32648dd7cc871ff5619da3cdc90ceedc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MusicCreatePieceEndToEndTestInput = {
  piece_id: string;
};
export type PieceCreateEndToEndTestMutation$variables = {
  input: MusicCreatePieceEndToEndTestInput;
};
export type PieceCreateEndToEndTestMutation$data = {
  readonly music_create_piece_end_to_end_test: {
    readonly success: boolean;
  };
};
export type PieceCreateEndToEndTestMutation = {
  variables: PieceCreateEndToEndTestMutation$variables;
  response: PieceCreateEndToEndTestMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "NoContentOutput",
    "kind": "LinkedField",
    "name": "music_create_piece_end_to_end_test",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PieceCreateEndToEndTestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PieceCreateEndToEndTestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "90f2e9a9b2bac93d061d34f815e697bd",
    "id": null,
    "metadata": {},
    "name": "PieceCreateEndToEndTestMutation",
    "operationKind": "mutation",
    "text": "mutation PieceCreateEndToEndTestMutation(\n  $input: MusicCreatePieceEndToEndTestInput!\n) {\n  music_create_piece_end_to_end_test(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a2f381d40d30dc01eb4b1f30cf5e250";

export default node;
